import React, { useState, useEffect } from "react";
import "./home.css";
import bgPhoto from "../../123.jpg";
import { Link } from "react-router-dom"; // Import Link

function Home() {
  const [randomPoems, setRandomPoems] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const endpoints = [
        "/data/people/posts.js",
        "/data/places/posts.js",
        "/data/voices/posts.js",
        "/data/faces/posts.js",
        "/data/littlelightbulbmoments/posts.js",
        "/data/colourmegreen/posts.js",
      ];
      try {
        const allPosts = [];

        await Promise.all(
          endpoints.map(async (path) => {
            const response = await fetch(path);
            if (!response.ok) {
              throw new Error(
                `HTTP error! status: ${response.status} at ${path}`
              );
            }
            const jsonData = await response.json();
            allPosts.push(
              ...jsonData.map((post) => ({
                ...post,
                route: path.split("/")[2],
              }))
            ); //add route info
          })
        );

        const shuffledPosts = allPosts.sort(() => 0.5 - Math.random()); // Shuffle all posts
        const selectedPosts = shuffledPosts.slice(0, 6); // Select first 6

        setRandomPoems(selectedPosts);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  
  console.log(randomPoems);
  return (
    <>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <img src={bgPhoto} alt="Website Background" style={{ maxWidth: "60%" }} />
      </div>
      <div className="card-grid" style={{ padding: "40px 20px", width: "95%", maxWidth: "1400px", margin: "0 auto" }}>
        {randomPoems.map((poem, index) => {
          const words = (poem.post || "").split(" ");
          const excerpt = words.slice(0, 20).join(" ") + (words.length > 20 ? "..." : "");

          const postLink = `/${poem.route}#${poem.name}`;

          return (
            <Link
              to={postLink}
              key={index}
              style={{ textDecoration: "none" }}
              className="post-card">
              <div className="post-card-img-placeholder">
                {poem.photo ? (
                  <img
                    src={`/data/${poem.route}/assets/${poem.photo}`}
                    alt={poem.name}
                  />
                ) : null}
              </div>
              <div className="post-card-content">
                <h3 className="post-card-title">{poem.name}</h3>
                <p className="post-card-excerpt">{excerpt}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </>
  );
}

export default Home;
